export default "__VITE_ASSET__DrhO6KE7__"